{
  "_comment": "[CI-LOCKED] Съдържанието на този файл е заключено. Приносът е добре дошъл, но валидирането на промените може да се забави.",
  "ACCESS_KEY_ALT": "Alt Shift $1",
  "ACCESS_KEY_FOR_MAC_ALT": "Control Option $1",
  "ACTIVITY_BOT_SAID_ALT": "Бот $1 каза:",
  "ACTIVITY_STATUS_VOICE_TRANSCRIPT_AGENT_LABEL": "Агент",
  "ACTIVITY_YOU_SAID_ALT": "Вие казахте:",
  "ACTIVITY_BOT_ATTACHED_ALT": "Прикачен бот:",
  "ACTIVITY_CODE_ALT": "Пример за код: $1",
  "ACTIVITY_CONTENT_CAUTION": "Генерираното от AI съдържание може да е неправилно",
  "ACTIVITY_CODE_CAUTION": "Генериран от AI код. Прегледайте го и го използвайте внимателно",
  "ACTIVITY_ERROR_BOX_TITLE": "Съобщение за грешка",
  "ACTIVITY_INTERACTIVE_FOOTNOTE_ALT": "Щракнете за взаимодействие.",
  "ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT": "Съобщението е интерактивно.",
  "ACTIVITY_INTERACTIVE_REASON_LINK_ALT": "Една или повече връзки в съобщението.",
  "ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT": "Изпращането е неуспешно.",
  "ACTIVITY_YOU_ATTACHED_ALT": "Вие прикачихте:",
  "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT": "1 прикачен файл.",
  "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT": "$1 прикачени файлове.",
  "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT": "$1 прикачени файлове.",
  "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT": "$1 прикачени файлове.",
  "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT": "$1 прикачени файлове.",
  "ACTIVITY_STATUS_SEND_FAILED_RETRY": "Изпращането е неуспешно. [Повторен опит][RETRY].",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING": "Изпращане",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT": "Изпратено в $1",
  "ACTIVITY_STATUS_TIMESTAMP_JUST_NOW": "Преди малко",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO": "Преди час",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO": "Преди минута",
  "ACTIVITY_STATUS_TIMESTAMP_TODAY": "Днес",
  "ACTIVITY_STATUS_TIMESTAMP_YESTERDAY": "Вчера",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE": "Грешка при анализиране на адаптивна карта",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER": "Грешка при рендиране на адаптивна карта",
  "ATTACHMENT_AUDIO": "Аудиоклип.",
  "ATTACHMENT_CARD": "Карта: $1 $2 $3",
  "ATTACHMENT_FILE": "Файл: $1",
  "ATTACHMENT_IMAGE": "Изображение",
  "ATTACHMENT_TEXT": "Текст: $1",
  "ATTACHMENT_VIDEO": "Видеоклип",
  "AVATAR_ALT": "Аватар на $1",
  "CAROUSEL_FLIPPER_NEXT_ALT": "Следващо",
  "CAROUSEL_FLIPPER_PREVIOUS_ALT": "Предишно",
  "CITATION_MODEL_DIALOG_ALT": "Цитат",
  "CLOSE_BUTTON_ALT": "Затваряне",
  "COLLAPSIBLE_GROUPING_TITLE": "Мислене…",
  "COLLAPSIBLE_GROUPING_TITLE.comment": "Това се показва, когато ботът съставя съобщения за отговор в група, ако не е предоставено резюме.",
  "COLLAPSE_BUTTON_LESS": "Показване на по-малко",
  "COLLAPSE_BUTTON_LESS.comment": "Това е текстът на бутон със стрелка за сгъване на група съобщения. Когато крайният потребител щракне върху бутона, групата съобщения се сгъва.",
  "COLLAPSE_BUTTON_MORE": "Показване на повече",
  "COLLAPSE_BUTTON_MORE.comment": "Това е текстът на бутон със стрелка за разгръщане на група съобщения. Когато крайният потребител щракне върху бутона, групата съобщения се разширява.",
  "CONNECTIVITY_STATUS_ALT_CONNECTED": "Установена връзка",
  "CONNECTIVITY_STATUS_ALT_CONNECTING": "Свързване...",
  "CONNECTIVITY_STATUS_ALT_FATAL": "Свързването не е възможно.",
  "CONNECTIVITY_STATUS_ALT_RECONNECTING": "Възникна прекъсване на мрежата. Повторно свързване...",
  "CONNECTIVITY_STATUS_ALT_RENDER_ERROR": "Грешка при рендиране. Моля, проверете конзолата или се свържете с разработчика на бота.",
  "CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION": "Свързването отнема повече време от обикновено.",
  "CONNECTIVITY_STATUS_ALT": "Състояние на възможността за връзка: $1",
  "COPY_BUTTON_TEXT": "Копиране",
  "COPY_BUTTON_COPIED_TEXT": "Копирано",
  "FEEDBACK_FORM_SUBMIT_BUTTON_LABEL": "Изпращане",
  "FEEDBACK_FORM_CANCEL_BUTTON_LABEL": "Отказ",
  "FEEDBACK_FORM_PLACEHOLDER": "Дайте колкото се може повече подробности, но не включвайте лична или чувствителна информация.",
  "FEEDBACK_FORM_TITLE": "Разкажете ни за вашето изживяване",
  "FILE_CONTENT_ALT": "„$1”",
  "FILE_CONTENT_DOWNLOADABLE_ALT": "Изтегляне на файл „$1”",
  "FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT": "Изтегляне на файл „$1” с размер $2",
  "FILE_CONTENT_WITH_SIZE_ALT": "„$1” с размер $2",
  "MARKDOWN_EXTERNAL_LINK_ALT": "Отваря се в нов прозорец; външен.",
  "RECEIPT_CARD_TAX": "Данък",
  "RECEIPT_CARD_TOTAL": "Обща сума",
  "RECEIPT_CARD_VAT": "ДДС",
  "REFERENCE_LIST_HEADER_ONE": "$1 препратка",
  "REFERENCE_LIST_HEADER_FEW": "$1 препратки",
  "REFERENCE_LIST_HEADER_MANY": "$1 препратки",
  "REFERENCE_LIST_HEADER_OTHER": "$1 препратки",
  "REFERENCE_LIST_HEADER_TWO": "$1 препратки",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_ALT": "Изтриване на прикачен файл $1",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_TOOLTIP": "Изтриване",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_FILE_ALT": "Файл",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_IMAGE_ALT": "Изображение",
  "SEND_BOX_IS_EMPTY_TOOLTIP_ALT": "Не може да се изпрати празно съобщение.",
  "SPEECH_INPUT_LISTENING": "Слушане...",
  "SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT": "Микрофонът е изключен",
  "SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT": "Микрофонът е включен",
  "SPEECH_INPUT_STARTING": "Начало...",
  "SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT": "Следващо",
  "SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT": "Предишно",
  "SUGGESTED_ACTIONS_LABEL_ALT": "Предложени действия",
  "TEXT_INPUT_ALT": "Поле за въвеждане на съобщение",
  "TEXT_INPUT_PLACEHOLDER": "Въведете съобщението си",
  "TEXT_INPUT_SPEECH_IDLE_PLACEHOLDER": "Започнете да говорите...",
  "TEXT_INPUT_SPEECH_LISTENING_PLACEHOLDER": "Слушане...",
  "TEXT_INPUT_SPEECH_PROCESSING_PLACEHOLDER": "Обработване...",
  "TEXT_INPUT_SPEECH_BOT_SPEAKING_PLACEHOLDER": "Говорете, за да прекъснете",
  "TEXT_INPUT_SEND_BUTTON_ALT": "Изпрати",
  "TEXT_INPUT_SPEAK_BUTTON_ALT": "Говорете",
  "TEXT_INPUT_UPLOAD_BUTTON_ALT": "Качване на файл",
  "TEXT_INPUT_TELEPHONE_KEYPAD_BUTTON_ALT": "Телефонна клавиатура",
  "TEXT_INPUT_DROP_ZONE": "Пуснете файловете тук",
  "TEXT_INPUT_LENGTH_EXCEEDED_ALT": "Допустимата дължина на съобщението е надхвърлена",
  "TELEPHONE_KEYPAD_INPUT_MESSAGE": "Поддържа въвеждане само по една цифра",
  "TEXT_INPUT_ATTACHMENTS_FEW": "$1 прикачени файла",
  "TEXT_INPUT_ATTACHMENTS_MANY": "$1 прикачени файла",
  "TEXT_INPUT_ATTACHMENTS_ONE": "1 прикачен файл",
  "TEXT_INPUT_ATTACHMENTS_OTHER": "$1 прикачени файла",
  "TEXT_INPUT_ATTACHMENTS_TWO": "$1 прикачени файла",
  "TOAST_ACCORDION_FEW": "$1 Известия: Щракнете тук, за да видите подробности",
  "TOAST_ACCORDION_MANY": "$1 Известия: Щракнете тук, за да видите подробности",
  "TOAST_ACCORDION_OTHER": "$1 Известия: Щракнете тук, за да видите подробности",
  "TOAST_ACCORDION_TWO": "$1 Известия: Щракнете тук, за да видите подробности",
  "TOAST_ALT_ERROR": "Грешка",
  "TOAST_ALT_INFO": "Информация",
  "TOAST_ALT_SUCCESS": "Успех",
  "TOAST_ALT_WARN": "Предупреждение",
  "TOAST_DISMISS_BUTTON": "Отхвърляне",
  "TOAST_TITLE_ALT": "Известяване",
  "TRANSCRIPT_ARIA_LABEL_ALT": "Хронология на чата, натиснете клавишите със стрелки, за да навигирате.",
  "TRANSCRIPT_ARIA_ROLE_ALT": "хронология на чата",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT": "Съобщението е интерактивно. Натиснете клавишите Shift и Tab 2 до 3 пъти, за да превключите към хронологията на чата. След това щракнете върху съобщението, за да взаимодействате.",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT": "Има една или повече връзки в съобщението. Натиснете клавишите Shift и Tab 2 до 3 пъти, за да превключите към хронологията на чата. След това щракнете върху съобщението, за да взаимодействате.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT": "В съобщението са предложени действия. Натиснете Shift Tab 2 до 3 пъти, за да ги изберете.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT": "В съобщението са предложени действия. Натиснете $1, за да ги изберете.",
  "TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT": "Неуспешно изпращане на съобщението.",
  "TRANSCRIPT_LIVE_REGION_NEW_MESSAGES_ALT": "Налични са нови съобщения. Натиснете $1, за да фокусирате бутона „$2“.",
  "TRANSCRIPT_MORE_MESSAGES": "Още съобщения",
  "TRANSCRIPT_NEW_MESSAGES": "Нови съобщения",
  "TRANSCRIPT_TERMINATOR_TEXT": "Край на хронологията на чата",
  "TYPING_INDICATOR_ALT": "Показване на индикатор за въвеждане",
  "TYPING_INDICATOR_SINGLE_TEXT": "$1 пише.",
  "TYPING_INDICATOR_MULTIPLE_TEXT": "$1 и други пишат.",
  "VIEW_CODE_BUTTON_TEXT": "Код",
  "VOTE_COMPLETE_ALT": "Обратната връзка е записана",
  "VOTE_COMPLETE_ALT.comment": "Това е за екранен четец. Етикетът на бутон с икони с палец нагоре/надолу. Етикетът се използва при записване на обратната връзка.",
  "VOTE_DISLIKE_ALT": "Не харесвам",
  "VOTE_LIKE_ALT": "Харесвам"
}